<template>
  <div v-if="details" class="jin-details-warp" @click="onShare">
    <PostHead />
    <div class="jin-details-body">
      <span class="date">发布时间：{{ dayjs(details.display_datetime).format('YYYY/MM/DD') }}</span>
      <div class="jin-details-body-warp">
        <div class="jin-details-body-item">
          <p>岗位职责</p>
          <ul>
            <li v-html="details.duty" />
          </ul>
        </div>
        <div class="jin-details-body-item">
          <p>岗位要求</p>
          <ul>
            <li v-html="details.job_requirements" />
          </ul>
        </div>
      </div>
    </div>
    <div v-if="IsPC" class="jin-details-footer">
      <div class="share" @click.stop="show = !show">
        <div class="share-con jin-pc" :class="{'share-con-active' : show}">
          <div class="qrcode-warp">
            <p>扫码分享职位</p>
            <QrcodeVue class="qrcode" :value="href" :size="170" />
          </div>
          <div class="link-warp">
            <p>或使用链接分享</p>
            <div class="link">
              <el-input v-model="href" readonly />
              <span ref="copy" class="copy" :data-clipboard-text="href" @click.stop="onCopy">复制链接</span>
            </div>
          </div>
        </div>
        <span>分享</span>
      </div>
      <div
        class="submit"
        @click.stop="onSubmit"
      >
        <span>立即投递</span>
      </div>
    </div>
    <div v-else class="jin-details-footer-m">
      <div class="to-card" @click="toCard">生成职位卡片</div>
      <div class="submit" @click.stop="onSubmit">立即投递</div>
    </div>
    <JobDetails v-if="isShowCard" :href="href" :show.sync="isShowCard" :category-info="category" :details="details" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import ClipboardJS from 'clipboard'
import JobDetails from './mobile/jobDetails'
import members from '@/utils/user'
import shareApp from '@/utils/wechat.share'

export default {
  components: {
    QrcodeVue,
    JobDetails
  },
  data() {
    return {
      show: false,
      isShowCard: false,
      href: window.location.href
    }
  },
  computed: {
    ...mapGetters([
      'details',
      'category',
      'userInfo'
    ])
  },
  watch: {
    show(n) {
      if (n) {
        this.$nextTick(() => {
          this.onCopy()
        })
      }
    },
    details: {
      handler() {
        this.init()
      },
      deep: true
    }
  },
  mounted() {
    console.log('details', this.details)
    this.init()
  },
  methods: {
    ...mapActions('position', ['GET_DETAILS', 'GET_CATEGORY', 'GET_LIST']),
    async init() {
      if (!(this.category && this.category.length)) await this.GET_CATEGORY()
      if (!this.details) await this.GET_DETAILS(this.$route.query.id)
      const name = this.$route.query.category_name || this.details.name
      if (this.details) {
        shareApp.wechat(`金十招聘-${name}`, '', `金十数据正在招聘${name}`)
      }
    },
    onSubmit() {
      if (this.userInfo && this.userInfo.nick) {
        this.$router.push(
          {
            path: `/list/resume`,
            query: {
              type: 'online',
              ...this.$route.query
            }
          }
        )
      } else {
        members.showLogin()
      }
    },
    onCopy() {
      var clipboard = new ClipboardJS(this.$refs.copy)
      clipboard.on('success', (e) => {
        this.Toast({
          message: '复制成功',
          type: 'success'
        })
      })
    },
    onShare() {
      this.show = false
    },
    async toCard() {
      this.isShowCard = true
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-m {
  .jin-details-warp {
    margin-top: 43px;
  }
}

.jin {
  &-details {
    &-warp {
      background: #fff;
    }

    &-body {
      &-warp {
        border-bottom: 1px solid #e8e8ea;
      }

      .date {
        color: #787b8a;
      }

      &-item {
        p {
          font-weight: 500;
          color: #3d4351;
        }

        ul {
          li {
            color: #787b8a;
          }
        }
      }
    }

    &-footer {
      display: flex;
      justify-content: center;

      .share,
      .submit {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .share {
        background: #f3f9fe;
        color: #4777f4;
      }

      .submit {
        color: #fff;
        background: #4777f4;
      }
    }
    &-footer-m {
      display: flex;
      justify-content: space-between;
      height: 40px;
      line-height: 40px;
      padding: 24px 18px 45px;
      text-align: center;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      .to-card {
        width: 165px;
        height: 40px;
        color: #4777F4;
        background: #F3F9FE;
        border-radius: 9px;
      }
      .submit {
        width: 165px;
        height: 40px;
        color: #fff;
        background: #4777F4;
        border-radius: 9px;
      }
    }
  }
}
</style>
